class BureaucratError extends Error {
  constructor(url, statusCode, statusText, ...params) {
    super(params);

    this.name = 'BureaucratError';
    this.url = url;
    this.statusCode = statusCode;
    this.statusText = statusText;
    this.message = `${this.url} ${this.statusCode} ${this.statusText}`;
  }
}

export default BureaucratError;
